<div [pTooltip]="'common.deleteDisabledAssigned' | translate" [tooltipDisabled]="!hasAssignments()" tooltipPosition="top" appendTo="body">
    <p-button
        [label]="'media.detail.delete' | translate"
        icon="pi pi-trash"
        severity="danger"
        [outlined]="true"
        [loading]="saving()"
        [disabled]="hasAssignments()"
        [attr.data-test]="testId()"
        (onClick)="onDelete()"
    />
</div>
